__turbopack_context__.v({
  "doubleWave": "DoubleWaveDivider-module-scss-module__-Vlt4W__doubleWave",
  "flip": "DoubleWaveDivider-module-scss-module__-Vlt4W__flip",
});
